import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {HintTypography} from 'patient-ping-remedy/packages/typography';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Separator = styled.div`
  height: 1px;
  margin-bottom: ${sizes.medium};
  background: ${colors.gray2};
`;

export const AssociationOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.medium};
`;

export const AssociationOptionLabel = styled.span`
  display: flex;
  flex-direction: column;
`;

export const AssociationOptionHint = styled(HintTypography)`
  font-weight: normal;
`;
